module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_3_es-ef14f18dbf43db83cb0a1e96ff531597.png";